/* =============================================================================

Overview user nodes:

--------------- Search
  /userdirectory =
    map: *whatever information user wants to provide* => user id
    (e.g. username => userid)
    Also used for slug urls => goalpilot.com/user/@username

--------------- Invitations
  /invitations = public invitations
  /invitations/{userid}
  /invitations/{email}

--------------- User
  /user/{userId}/status = information only friends can see
    - isOnline, lastSeen
    - currentTask / currentGoal
    (see also get_fake_contact_by_id)
  /user/{userId}/incomming_invitations
  /user/{userId}/outgoing_invitations
  /user/{userId}/msginbox
    - sender
    - message
  /user/{userId}/public = anybody can see (or friends can see depending on settings)
    - level
  /user/{userId}/settings ( = private )
  /user/{userId}/contacts ( userId = true ) = people who have access to my data / my status

  /user/{userId}/readonly
  - reward = +50 everytime user invites somebody

  /user/{userId}/referral -> readonly ??
    {
      user: activated,
      code: numOfActivations
    }

  /user/{userId}/commitment_settings/{*}
  /user/{userId}/sequence_settings/{*}
  /user/{userId}/goal_settings/{*}
  /user/{userId}/challenge_settings/{*}
  /user/{userId}/visionboard_settings/{*}

  /user/{userId}/ideas/{*}
  /user/{userId}/timer

  /user/{userId}/analysis_log/{*} = records all user actions (PRO feature?)
  /user/{userId}/daily_settings/{yymmdd} = DailyCommitmentTargetsAndSummary
    - streak:          yes/no
    - hours_planned:   58
    - hours_worked:    14
    - amount_planned:  10
    - amount_finished: 9

  Timeslots:
  /user/{userId}/timeslot_collections

  Calendar:
  /user/{userId}/calendar_items/{*}

--------------- Team / Organization
  /team/{teamId} = Goal?

  /organization/{organizationId}
  /organization/members/ (userId, isAdmin = can add, remove)
  /organization/userdirectory (same as /userdirectory but with more information, email, names, etc.)

  Allow to search within my organization or worldwide

QUESTIONS:

  QUESTION: Question how do we fetch outstanding invitations in goals?
  ANSWER:   /invitations/goal/{goalId}

  QUESTION: Where are outgoing invitations stored?
  ANSWER:   /user/{userId}/outgoing_invitations

  QUESTION: Who will get reward when two users invite a user?
  ANSER:    ?

  QUESTION: How to support multiple accounts per user (work, private)
  1: Allow to login to two accounts and switch (like google) - not possible
  2: Link accounts = Share information between accounts -
     everything has to be checked against multiple user ids!

  "Multiple simultaneous logins in the same project is not supported with Firebase Auth."

SECURITY RULES

  Relationship between all users and current user
  - TODO

  Relationship between this user and current user
  - TODO

============================================================================= */

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {
    currentUserId({ $store }) {
      // TODO: userAuth.uid
      return $store.defaultUserId;
    }
  },
  schema: {}
};
